import React from 'react'

export function AppFooter() {
  return (
    <footer className="padding full">
      <div className="footer-content">
        <div>
          <h2>Support</h2>
          <ul>
            <li>
              <a href="#">Help Center</a>
            </li>
            <li>
              <a href="#">AirCover</a>
            </li>
            <li>
              <a href="#">Anti-discrimination</a>
            </li>
            <li>
              <a href="#">Disability support</a>
            </li>
            <li>
              <a href="#">Cancellation options</a>
            </li>
            <li>
              <a href="#">Report neighborhood concern</a>
            </li>
          </ul>
        </div>
        <div>
          <h2>Hosting</h2>
          <ul>
            <li>
              <a href="#">StayFlex your home</a>
            </li>
            <li>
              <a href="#">AirCover for Hosts</a>
            </li>
            <li>
              <a href="#">Hosting resources</a>
            </li>
            <li>
              <a href="#">Community forum</a>
            </li>
            <li>
              <a href="#">Hosting responsibly</a>
            </li>
            <li>
              <a href="#">StayFlex-friendly apartments</a>
            </li>
            <li>
              <a href="#">Join a free Hosting class</a>
            </li>
          </ul>
        </div>
        <div>
          <h2>StayFlex</h2>
          <ul>
            <li>
              <a href="#">Newsroom</a>
            </li>
            <li>
              <a href="#">New features</a>
            </li>
            <li>
              <a href="#">Careers</a>
            </li>
            <li>
              <a href="#">Investors</a>
            </li>
            <li>
              <a href="#">Gift cards</a>
            </li>
            <li>
              <a href="#">StayFlex.org emergency stays</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 StayFlex, Inc.</p>
        <div className="footer-right">
          <a href="#">Terms</a>
          <a href="#">Sitemap</a>
          <a href="#">Privacy</a>
          <a href="#">Your Privacy Choices</a>
        </div>
      </div>
    </footer>
  )
}
